// extracted by mini-css-extract-plugin
export default {"intro":"ModalEditarDatosEstudiosLead_intro__Cwmi8","section":"ModalEditarDatosEstudiosLead_section__2d58g","input":"ModalEditarDatosEstudiosLead_input__hzbQk"};